export function defineCssLoader() {
    if (customElements.get('gem-css-loader')) {
        return;
    }

    const paths = new Set<string>();

    customElements.define(
        'gem-css-loader',
        class extends HTMLElement {
            connectedCallback() {
                const cssPath = this.getAttribute('path');
                if (!cssPath) {
                    throw new Error('gem-css-loader: path attribute is required');
                }

                const component = this.nextElementSibling;
                if (!component?.matches('.gem-module') && !component?.tagName.toLowerCase().startsWith('gem-')) {
                    throw new Error('gem-css-loader: missing component');
                }

                if (paths.has(cssPath)) {
                    return;
                }

                paths.add(cssPath);

                const visibilityObserver = new IntersectionObserver(
                    (entries) => {
                        if (entries.some((entry) => entry.isIntersecting)) {
                            this.#loadCssWhenVisible(cssPath);
                            visibilityObserver.disconnect();
                        }
                    },
                    // The component JS bundle will load with 300px, so we can start loading the CSS a bit earlier to avoid FOUC
                    {rootMargin: '0px 0px 400px 0px'},
                );

                visibilityObserver.observe(component);
            }

            #loadCssWhenVisible(cssPath: string) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = cssPath;
                document.head.appendChild(link);
            }
        },
    );
}
